module.exports = __webpack_public_path__ + "static/header-circles-ff964053d7e8c21f74538c6e99447df2.svg";